interface StopDetails {
    stop_id: number;
    stop_name: string;
    stop_code: string;
    location: string;
}

export interface IRouteOnBoardState {
    route_id: number;
    route_name: string;
    stop_details: StopDetails[];
}

export enum IRouteOnBoardActionTypes {
    FETCH_ROUTES_LIST_REQUEST = 'FETCH_ROUTES_LIST_REQUEST',
    FETCH_ROUTES_LIST_SUCCESS = 'FETCH_ROUTES_LIST_SUCCESS',
    FETCH_ROUTES_LIST_FAILURE = 'FETCH_ROUTES_LIST_FAILURE',

    FETCH_STOPS_LIST_REQUEST = 'FETCH_STOPS_LIST_REQUEST',
    FETCH_STOPS_LIST_SUCCESS = 'FETCH_STOPS_LIST_SUCCESS',
    FETCH_STOPS_LIST_FAILURE = 'FETCH_STOPS_LIST_FAILURE',

    UPDATE_ROUTE_REQUEST = 'UPDATE_ROUTE_REQUEST',
    UPDATE_ROUTE_SUCCESS = 'UPDATE_ROUTE_SUCCESS',
    UPDATE_ROUTE_FAILURE = 'UPDATE_ROUTE_FAILURE',
    RESET_UPDATE_ROUTE_STATE = 'RESET_UPDATE_ROUTE_STATE',

    ADD_ROUTE_REQUEST = 'ADD_ROUTE_REQUEST',
    ADD_ROUTE_SUCCESS = 'ADD_ROUTE_SUCCESS',
    ADD_ROUTE_FAILURE = 'ADD_ROUTE_FAILURE',
    RESET_ADD_ROUTE_STATE = 'RESET_ADD_ROUTE_STATE',
}

export type IRouteOnBoardActionCreator = {
    type: string;
    payload: IRouteOnBoardState;
  };